module.exports = __webpack_public_path__ + "media/images/ic-select_inbox-e425b764aa0686e3f663d08cdc58a17d.svg";